import React from 'react';
import { Helmet } from 'react-helmet-async';
import LocationSearchBar from '../components/locations/LocationSearchBar';
import ServicesList from '../components/services/ServicesList';
import LocationSearch from '../components/locations/LocationSearch';
import BrandsList from '../components/brands/BrandsList';
import DisclaimerBanner from '../components/shared/DisclaimerBanner';
import ServiceFAQs from '../components/faq/ServiceFAQs';
import ActionButtons from '../components/shared/ActionButtons';

export default function Home() {
  return (
    <>
      <Helmet>
        <title>Parakh Services - Expert Home Appliance Repair Service Center | Call 9828351602, 8559929954</title>
        <meta name="description" content="Professional repair service center for AC, Washing Machine, Refrigerator, TV, and RO Systems across India. Expert technicians and same-day service available. Call 9828351602, 8559929954" />
      </Helmet>

      {/* Hero Section with Main Content */}
      <section className="bg-gradient-to-b from-blue-50 to-white py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-gray-900 mb-6">
              <span className="block">Expert Home Appliance</span>
              <span className="block text-blue-600">Repair Service Center</span>
              <span className="block text-2xl mt-4 font-medium">Call 9828351602, 8559929954</span>
            </h1>
            <p className="mt-3 max-w-2xl mx-auto text-lg sm:text-xl text-gray-600">
              Professional repair service center for all major brands of AC, Washing Machine, 
              Refrigerator, Microwave, TV, and RO Systems across India.
            </p>
          </div>

          {/* Location Search */}
          <div className="max-w-2xl mx-auto mb-8">
            <LocationSearch />
          </div>

          {/* Action Buttons */}
          <div className="mt-8">
            <ActionButtons className="justify-center" />
          </div>
        </div>
      </section>

      {/* Services Section */}
      <ServicesList />

      {/* Location Selector Section */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <h2 className="text-3xl font-bold text-gray-900">Find Service Center in Your Area</h2>
            <p className="mt-4 text-lg text-gray-600">Select your location to see available services</p>
          </div>
          <div className="max-w-2xl mx-auto">
            <LocationSearchBar />
          </div>
        </div>
      </section>

      {/* Brands Section */}
      <BrandsList />

      {/* FAQs Section */}
      <ServiceFAQs />

      {/* Disclaimer Banner */}
      <DisclaimerBanner />
    </>
  );
}